import React, { useEffect, useState } from 'react';
import './App.css';
import { supabase } from './supabaseClient'; // Supabase 클라이언트 import
import ImageUpload from './components/ImageUpload'; // ImageUpload 컴포넌트 import

function App() {
  const [uploadedImageUrl, setUploadedImageUrl] = useState<string | null>(null);

  useEffect(() => {
    // Supabase 클라이언트가 제대로 초기화되었는지 확인 (개발자 도구 콘솔에서 확인 가능)
    console.log('App component mounted. Supabase client:', supabase);
  }, []);

  const handleImageUploadSuccess = (imageUrl: string) => {
    console.log('Image successfully uploaded:', imageUrl);
    setUploadedImageUrl(imageUrl);
    alert('이미지 업로드 완료! 이제 AI 추천을 시작할 수 있습니다.');
    // TODO: 여기에 AI 추천 로직을 트리거하는 기능을 추가할 수 있습니다.
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>👗 Fashion AI Recommender 👔</h1>
        <p>당신을 위한 최고의 스타일을 AI가 찾아드립니다.</p>
        {uploadedImageUrl ? (
          <div>
            <p>업로드된 이미지:</p>
            <img src={uploadedImageUrl} alt="Uploaded" style={{ maxWidth: '200px', borderRadius: '8px' }} />
            {/* TODO: 여기에 AI 추천 결과를 보여줄 컴포넌트를 추가할 수 있습니다. */}
          </div>
        ) : (
          <ImageUpload onUploadSuccess={handleImageUploadSuccess} />
        )}
      </header>
    </div>
  );
}

export default App;
